<template>
  <div class="index-page">
    <canvas id="canvas-bg"></canvas>

    <div class="main-container">
      <div class="text-area">
        <h1>欢迎来到 <br><span>小葱的专属</span>聊天室</h1>
        <p class="description">
          这里是一个基于WebSorket开发的实时交流区域。你可以在这里无时无刻的与我进行联系！无需加我好友，仅需注册登录系统即可！很期待与你的聊天呢~
        </p>
      </div>
      
      <div class="button-area">
        <router-link to="/login" class="slant-btn">
          <span>点击这里和小葱聊天吧~</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      canvas: null,
      ctx: null,
      particlesArray: [],
      mouse: { x: null, y: null, radius: 150 },
      animationId: null,
      handleResize: null,
      handleMouseMove: null
    }
  },
  mounted() {
    // --- 动态背景脚本 (简单的粒子连接效果) ---
    this.canvas = document.getElementById('canvas-bg')
    this.ctx = this.canvas.getContext('2d')
    this.canvas.width = window.innerWidth
    this.canvas.height = window.innerHeight

    const numberOfParticles = 80 // 粒子数量

    // 鼠标交互
    this.handleMouseMove = (event) => {
      this.mouse.x = event.x
      this.mouse.y = event.y
    }
    window.addEventListener('mousemove', this.handleMouseMove)

    const self = this
    class Particle {
      constructor(x, y, directionX, directionY, size, color) {
        this.x = x
        this.y = y
        this.directionX = directionX
        this.directionY = directionY
        this.size = size
        this.color = color
      }
      draw() {
        self.ctx.beginPath()
        self.ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2, false)
        self.ctx.fillStyle = 'rgba(100, 255, 218, 0.3)' // 粒子颜色
        self.ctx.fill()
      }
      update() {
        // 边界检查
        if (this.x > self.canvas.width || this.x < 0) {
          this.directionX = -this.directionX
        }
        if (this.y > self.canvas.height || this.y < 0) {
          this.directionY = -this.directionY
        }
        
        // 鼠标排斥交互
        let dx = self.mouse.x - this.x
        let dy = self.mouse.y - this.y
        let distance = Math.sqrt(dx * dx + dy * dy)
        if (distance < self.mouse.radius + this.size) {
          if (self.mouse.x < this.x && this.x < self.canvas.width - this.size * 10) {
            this.x += 2
          }
          if (self.mouse.x > this.x && this.x > this.size * 10) {
            this.x -= 2
          }
          if (self.mouse.y < this.y && this.y < self.canvas.height - this.size * 10) {
            this.y += 2
          }
          if (self.mouse.y > this.y && this.y > this.size * 10) {
            this.y -= 2
          }
        }
        this.x += this.directionX * 0.5
        this.y += this.directionY * 0.5
        this.draw()
      }
    }

    const init = () => {
      self.particlesArray = []
      for (let i = 0; i < numberOfParticles; i++) {
        let size = (Math.random() * 3) + 1
        let x = (Math.random() * ((innerWidth - size * 2) - (size * 2)) + size * 2)
        let y = (Math.random() * ((innerHeight - size * 2) - (size * 2)) + size * 2)
        let directionX = (Math.random() * 2) - 1
        let directionY = (Math.random() * 2) - 1
        self.particlesArray.push(new Particle(x, y, directionX, directionY, size, 'white'))
      }
    }

    const connect = () => {
      for (let a = 0; a < self.particlesArray.length; a++) {
        for (let b = a; b < self.particlesArray.length; b++) {
          let distance = ((self.particlesArray[a].x - self.particlesArray[b].x) * (self.particlesArray[a].x - self.particlesArray[b].x)) + ((self.particlesArray[a].y - self.particlesArray[b].y) * (self.particlesArray[a].y - self.particlesArray[b].y))
          if (distance < (self.canvas.width / 7) * (self.canvas.height / 7)) {
            let opacityValue = 1 - (distance / 15000)
            self.ctx.strokeStyle = 'rgba(100, 255, 218,' + opacityValue * 0.1 + ')' // 连线颜色
            self.ctx.lineWidth = 1
            self.ctx.beginPath()
            self.ctx.moveTo(self.particlesArray[a].x, self.particlesArray[a].y)
            self.ctx.lineTo(self.particlesArray[b].x, self.particlesArray[b].y)
            self.ctx.stroke()
          }
        }
      }
    }

    const animate = () => {
      self.animationId = requestAnimationFrame(animate)
      self.ctx.clearRect(0, 0, innerWidth, innerHeight)
      for (let i = 0; i < self.particlesArray.length; i++) {
        self.particlesArray[i].update()
      }
      connect()
    }

    this.handleResize = () => {
      self.canvas.width = innerWidth
      self.canvas.height = innerHeight
      self.mouse.radius = ((self.canvas.height / 80) * (self.canvas.width / 80))
      init()
    }

    window.addEventListener('resize', this.handleResize)

    init()
    animate()
  },
  beforeUnmount() {
    // Vue 3 推荐的方式：在 beforeUnmount 中清理
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
    if (this.handleMouseMove) {
      window.removeEventListener('mousemove', this.handleMouseMove)
    }
    if (this.animationId) {
      cancelAnimationFrame(this.animationId)
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');

:root {
  /* 蓝白配色定义 */
  --deep-blue: #020c1b;
  --tech-blue: #0a192f;
  --highlight-blue: #64ffda; /* 虽然叫青色，但在蓝背景下是高亮蓝光感 */
  --bright-white: #ffffff;
  --secondary-white: #ccd6f6;
}

.index-page {
  font-family: 'Inter', sans-serif;
  background-color: var(--deep-blue);
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px; /* 为3D效果做准备 */
  position: relative;
}

/* --- 动态全屏背景 (Canvas 粒子网络) --- */
#canvas-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: radial-gradient(ellipse at bottom, var(--tech-blue) 0%, var(--deep-blue) 100%);
}

/* --- 主体内容容器 --- */
/* 使用倾斜切分构图，打破平衡感 */
.main-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 85%;
  max-width: 1200px;
  z-index: 10;
  /* 整体轻微倾斜，制造动势 */
  transform: skewY(-2deg);
}

/* 左侧说明文字区域 */
.text-area {
  flex: 1;
  padding-right: 50px;
}

h1 {
  font-size: 4rem;
  font-weight: 900;
  color: var(--bright-white);
  line-height: 1.1;
  margin-bottom: 1.5rem;
  text-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h1 span {
  color: var(--highlight-blue); /* 强调色 */
}

p.description {
  font-size: 1.2rem;
  color: var(--secondary-white);
  line-height: 1.6;
  max-width: 500px;
  /* 让文字反向倾斜一点，保持阅读舒适度 */
  transform: skewY(2deg);
}

/* --- 右侧按钮区域 (核心交互) --- */
.button-area {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  /* 按钮区域的倾斜容器 */
  transform: rotate(-5deg) skewX(-5deg);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* 核心呼吸按钮 */
.slant-btn {
  position: relative;
  display: inline-block;
  padding: 1.8rem 4rem;
  background: var(--bright-white);
  color: var(--deep-blue);
  font-size: 1.3rem;
  font-weight: 800;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  border: none;
  cursor: pointer;
  border-radius: 12px; /* 添加圆角，移动端更友好 */
  /* 初始状态：带呼吸灯的倾斜方块 */
  box-shadow: 10px 10px 0px rgba(100, 255, 218, 0.2),
    0 0 20px rgba(100, 255, 218, 0.1);
  transition: all 0.4s ease;
  animation: blueBreath 3s infinite ease-in-out;
}

/* 按钮上的文字需要反向修正一点角度，增加设计张力 */
.slant-btn span {
  display: block;
  transform: skewX(5deg);
}

/* 移动端去掉倾斜效果 */
@media (max-width: 768px) {
  .slant-btn {
    transform: none !important; /* 移动端去掉所有transform */
    border-radius: 12px; /* 移动端使用圆角 */
    box-shadow: 0 4px 12px rgba(100, 255, 218, 0.3),
      0 0 20px rgba(100, 255, 218, 0.1); /* 简化阴影效果 */
    animation: none; /* 移动端去掉呼吸动画 */
  }
  
  .slant-btn span {
    transform: none !important; /* 移动端文字不倾斜 */
  }
  
  .button-area {
    transform: none !important; /* 移动端按钮区域不倾斜 */
  }
  
  .button-area:hover {
    transform: none !important; /* 移动端hover效果也去掉 */
  }
  
  .button-area:hover .slant-btn {
    transform: scale(1.02) !important; /* 移动端只保留轻微缩放 */
    animation: none;
  }
}

/* --- 呼吸动画定义 --- */
@keyframes blueBreath {
  0%, 100% {
    transform: scale(1);
    box-shadow: 10px 10px 0px rgba(100, 255, 218, 0.2), 0 0 20px rgba(100, 255, 218, 0.1);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 15px 15px 0px rgba(100, 255, 218, 0.4), 0 0 40px rgba(100, 255, 218, 0.3);
  }
}

/* --- 强交互 Hover 效果 --- */
/* 当鼠标悬停在按钮区域时 */
.button-area:hover {
  /* 容器瞬间摆正，产生强烈的视觉冲击 */
  transform: rotate(0deg) skewX(0deg) scale(1.05);
}

.button-area:hover .slant-btn {
  /* 按钮颜色反转，变为高亮蓝底白字 */
  background: var(--highlight-blue);
  color: var(--deep-blue);
  /* 停止呼吸动画，变为高能常亮状态 */
  animation-play-state: paused;
  box-shadow: 0px 0px 0px rgba(100, 255, 218, 0),
    0 0 60px rgba(100, 255, 218, 0.8);
  transform: scale(1.05);
}

.button-area:hover .slant-btn span {
  transform: skewX(0deg); /* 文字也摆正 */
}

/* 移动端适配 */
@media (max-width: 768px) {
  .index-page {
    height: 100vh;
    height: 100dvh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 20px 15px;
  }
  
  .main-container {
    flex-direction: column;
    transform: skewY(0deg);
    text-align: center;
    width: 100%;
    max-width: 100%;
    padding: 0;
  }
  
  .text-area {
    padding-right: 0;
    margin-bottom: 2.5rem;
    width: 100%;
  }
  
  h1 {
    font-size: 2rem;
    line-height: 1.2;
    margin-bottom: 1.2rem;
  }
  
  p.description {
    transform: skewY(0deg);
    margin: 0 auto;
    font-size: 1rem;
    line-height: 1.5;
    max-width: 100%;
    padding: 0 10px;
  }
  
  .button-area {
    justify-content: center;
    transform: none !important;
    width: 100%;
    align-items: center;
  }
  
  .slant-btn {
    width: 100%;
    max-width: 300px;
    padding: 1.5rem 2.5rem;
    font-size: 1.1rem;
    min-height: 56px;
    transform: none !important; /* 确保没有倾斜 */
    border-radius: 12px; /* 圆角按钮 */
    box-shadow: 0 4px 12px rgba(100, 255, 218, 0.3),
      0 0 20px rgba(100, 255, 218, 0.1); /* 简化阴影 */
    animation: none; /* 移动端去掉动画 */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .slant-btn span {
    transform: none !important; /* 文字不倾斜 */
    display: block;
  }
  
  .slant-btn:active {
    transform: scale(0.98) !important; /* 点击反馈 */
    box-shadow: 0 2px 8px rgba(100, 255, 218, 0.2);
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .index-page {
    padding: 15px 10px;
  }
  
  h1 {
    font-size: 1.75rem;
    margin-bottom: 1rem;
  }
  
  p.description {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .text-area {
    margin-bottom: 2rem;
  }
  
  .slant-btn {
    padding: 1.2rem 2rem;
    font-size: 1rem;
    min-height: 50px;
    transform: none !important; /* 小屏确保没有倾斜 */
    border-radius: 10px; /* 小屏圆角 */
    box-shadow: 0 3px 10px rgba(100, 255, 218, 0.25),
      0 0 15px rgba(100, 255, 218, 0.1); /* 小屏简化阴影 */
    animation: none; /* 小屏去掉动画 */
  }
  
  .slant-btn:active {
    transform: scale(0.97) !important; /* 点击反馈 */
  }
}

/* 横屏适配 */
@media (max-width: 768px) and (orientation: landscape) {
  .index-page {
    padding: 15px;
  }
  
  .main-container {
    flex-direction: row;
    align-items: center;
    gap: 30px;
  }
  
  .text-area {
    flex: 1;
    margin-bottom: 0;
    text-align: left;
  }
  
  h1 {
    font-size: 1.8rem;
  }
  
  p.description {
    font-size: 0.9rem;
    padding: 0;
  }
  
  .button-area {
    flex: 0 0 auto;
    justify-content: flex-end;
  }
  
  .slant-btn {
    max-width: 250px;
  }
}
</style>

